export default function (model) {
  const formData = new FormData();
  const camelToSnake = camel => camel.replace(/[A-Z]/g, val => `_${val.toLowerCase()}`);

  Object.keys(model).forEach(key => {
    const value = model[key];

    if (value && value.constructor === Array) {
      value.forEach((item, index) => {
        formData.append(`${camelToSnake(key)}[${index}]`, item);
      });
    } else {
      formData.append(camelToSnake(key), value);
    }
  });

  return formData;
}



// WEBPACK FOOTER //
// ./app/features/shared/services/toFormData.js